import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ConvivaApi } from 'src/app/conviva-api';
import { DefaultResponse } from '../models/DefaultResponse';

@Injectable({ providedIn: 'root' })
export class NotificacaoService {
  private api = ConvivaApi;

  constructor(private http: HttpClient) {}

  public getContagemPendenciasValidacao(
    codigoDiretoria: number,
    codigoEscola: number,
    codigoPerfil: number
  ): Observable<DefaultResponse> {
    const q = `codigoDiretoria=${codigoDiretoria}&codigoEscola=${codigoEscola}&codigoPerfil=${codigoPerfil}`;
    return this.http
      .get<DefaultResponse>(`${this.api.Notificacao.getContagemPendenciasValidacao}?${q}`)
      .pipe(map((response: DefaultResponse) => response));
  }
}
